
export default {
    name: 'IconCommission',
    props: {
        width: {
            type: String,
            default: '23px'
        },
        height: {
            type: String,
            default: '23px'
        },
        color: {
            type: String,
            default: '#303030'
        }
    }
}
